import { createBrowserRouter } from 'react-router-dom';
import { PATH } from 'constants/path';
import ServiceLayout from 'components/layout/ServiceLayout';
import OtpPage from 'features/login/OtpPage';
import StudentElearningGuard from 'components/guard/StudentElearningGuard';
import StudentElearningLayout from 'components/layout/StudentElearningLayout';
import ElearningStudentResultPage from 'features/elearning/pages/ElearningStudentResultPage';
import ElearningStudentTestPage from 'features/elearning/pages/ElearningStudentTestPage';
import ElearningStudentLoginPage from 'features/elearning/pages/ElearningStudentLoginPage';
import ElearningStudentCoursePage from 'features/elearning/pages/ElearningStudentCoursePage';
import ElearningStudentMyPage from 'features/elearning/pages/ElearningStudentMyPage';
import ElearningStudentVideoPage from 'features/elearning/pages/ElearningStudentVideoPage';
import ElearningStudentTestDetailPage from 'features/elearning/pages/ElearningStudentTestDetailPage';
import ElearningStudentArticlePage from 'features/elearning/pages/ElearningStudentArticlePage';
import ElearningStudentBookPage from 'features/elearning/pages/ElearningStudentBookPage';
import ForceChangePasswordPage from 'features/elearning/pages/ForceChangePasswordPage';
import ElearningStudentInfoConfirmationPage from 'features/elearning/pages/ElearningStudentInfoConfirmationPage';
import ElearningAttemptResultPage from 'features/elearning/pages/ElearningAttemptResultPage';
import { DrivingTestPage, LoginPage, NotFoundPage } from 'features';
import ElearningForumPage from 'features/elearning/pages/ElearningForumPage';

const router = createBrowserRouter([
  {
    path: PATH.ELEARNING.LOGIN,
    element: <ElearningStudentLoginPage />,
  },
  {
    path: PATH.ELEARNING.CHANGE_PASSWORD,
    element: <ForceChangePasswordPage />,
  },
  {
    element: <StudentElearningGuard />,
    errorElement: <NotFoundPage />,
    children: [
      {
        path: PATH.ELEARNING.STUDENT.INFO_CONFIRMATION,
        element: <ElearningStudentInfoConfirmationPage />,
      },
      {
        element: <StudentElearningLayout />,
        children: [
          {
            path: PATH.ELEARNING.STUDENT.ROOT,
            element: <ElearningStudentMyPage />,
          },
          {
            path: PATH.ELEARNING.STUDENT.COURSE,
            element: <ElearningStudentCoursePage />,
          },
          {
            path: PATH.ELEARNING.STUDENT.VIDEO,
            element: <ElearningStudentVideoPage />,
          },
          {
            path: PATH.ELEARNING.STUDENT.RESULT,
            element: <ElearningStudentResultPage />,
          },
          {
            path: PATH.ELEARNING.STUDENT.TEST,
            element: <ElearningStudentTestPage />,
          },
          {
            path: PATH.ELEARNING.STUDENT.TEST_DETAIL,
            element: <ElearningStudentTestDetailPage />,
          },
          {
            path: PATH.ELEARNING.STUDENT.ARTICLE,
            element: <ElearningStudentArticlePage />,
          },
          {
            path: PATH.ELEARNING.STUDENT.BOOK,
            element: <ElearningStudentBookPage />,
          },
          {
            path: PATH.ELEARNING.STUDENT.ATTEMPT_RESULT,
            element: <ElearningAttemptResultPage />,
          },
          {
            path: PATH.ELEARNING.STUDENT.FORUM,
            element: <ElearningForumPage />,
          },
        ],
      },
    ],
  },
  {
    path: PATH.AUTH.SIGNIN,
    element: <LoginPage />
  },
  {
    path: PATH.AUTH.OTP,
    element: <OtpPage />
  },
  {
    path: PATH.NOT_FOUND,
    element: <ServiceLayout pageTitle="404" backTo={PATH.HOME}>
      <NotFoundPage />
    </ServiceLayout>
  },
  {
    path: PATH.DRIVING.TEST,
    element: <ServiceLayout pageTitle="Lý thuyết sát hạch">
      <DrivingTestPage />
    </ServiceLayout>
  },
]);

export default router;
